export const MAX_CHAR_LIMIT = 500000;
export const MAX_FILE_SIZE = 1024 * 1024 * 8; //8Mb
export const FILE_TYPE = {
  PDF: "PDF",
  XLSX: "XLSX",
  DOCX: "DOCX",
} as const;

export const MIME_TYPE = {
  "application/pdf": FILE_TYPE.PDF,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": FILE_TYPE.XLSX,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": FILE_TYPE.DOCX,
} as const;

type ModelDescription = {
  name: string;
  description: string;
};

export const modelsDescriptionMap: Record<string, ModelDescription> = {
  "gpt-4.1-mini-2025-04-14": {
    name: "GPT-4.1-mini",
    description: "Fast model for everyday tasks.",
  },
  "o3-mini-2025-01-31": {
    name: "o3-mini",
    description: "Reasoning model, good for problem solving, math or code.",
  },
  "gemini-2.5-pro": {
    name: "2.5 Pro",
    description: "High performance, best for coding and complex tasks.",
  },
  "gemini-2.5-flash": {
    name: "2.5 Flash",
    description: "Fast, designed for daily tasks.",
  },
};

export const CHAT_FILE_UPLOAD_API_PATH = `${process.env.REACT_APP_BACKEND_URL}/api/v2/enhanced/chat`;
export const NEW_CHAT_API_PATH = `${process.env.REACT_APP_BACKEND_URL}/api/v2/enhanced/chat/new`;
export const ASK_GPC_CHAT_API_PATH = `${process.env.REACT_APP_BACKEND_URL}/api/v2/askgpc/chat`;

export const UPLOAD_FILE_BUTTON_TEXT = "Upload File";
export const UPLOAD_FILE_TOOLTIP_TEXT = "Supported file types:";
